import {
  searchProducts,
  type ProductResponseDto,
  type SearchProductsData,
} from '@helios/frontend-api-v2-client';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getFriendlyError } from '../../utils/error';

export const SEARCH_PRODUCTS_QUERY_KEY = 'search-products';

interface UseSearchProductsProps {
  data: ProductResponseDto[];
  error: string | null;
  isLoading: boolean;
  isFetched: boolean;
}

interface UseSearchProductsParams {
  body?: SearchProductsData['body'];
}

export const useSearchProducts = ({ body = {} }: UseSearchProductsParams = {}): UseSearchProductsProps => {
  const { data, error, isPending, isFetched } = useQuery({
    queryKey: [SEARCH_PRODUCTS_QUERY_KEY, body],
    queryFn: () => searchProducts({ body }).then((r) => r.data),
  });

  return {
    data: data ?? [],
    error: getFriendlyError(error as AxiosError, 'products') || null,
    isLoading: isPending,
    isFetched,
  };
};
